import React, { useState } from 'react';
import { Search, X, ArrowRight } from 'lucide-react';
import GlassCard from './GlassCard';

const SearchModal = ({ isOpen, onClose, onSearch, loading = false }) => {
  const [searchAddress, setSearchAddress] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchAddress.trim()) {
      onSearch(searchAddress.trim());
      setSearchAddress('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <GlassCard className="w-full max-w-md p-4 sm:p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition"
        >
          <X size={20} />
          <span className="sr-only">Close</span>
        </button>

        {/* Title */}
        <h2 className="text-xl font-bold text-white mb-6 text-center">
          Search for another jeeters
        </h2>

        {/* Search Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
            <input
              type="text"
              value={searchAddress}
              onChange={(e) => setSearchAddress(e.target.value)}
              placeholder="Enter Solana wallet address"
              className="w-full bg-[#1a1a1a] border border-[#404040] rounded-lg pl-12 pr-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-green-500 transition-all"
              autoFocus
            />
          </div>
          
          <button
            type="submit"
            disabled={loading || !searchAddress.trim()}
            className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-semibold px-6 py-3 rounded-lg flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Searching...' : 'Search'}
            {!loading && <ArrowRight size={18} />}
          </button>
        </form>
      </GlassCard>
    </div>
  );
};

export default SearchModal;

